import { parse } from 'query-string';

export const hasQueryMailInLocation = () => {
  if (typeof location !== 'undefined' && location.search) {
    const queryS = parse(location.search);
    return queryS.mail === '1';
  }
  return false;
};
